export default __webpack_public_path__ + "static/media/whatsapp.b4e27b03.svg";